export const SUPLIER_LIST_REQUEST = 'SUPLIER_LIST_REQUEST'
export const SUPLIER_LIST_SUCCESS = 'SUPLIER_LIST_SUCCESS'
export const SUPLIER_LIST_FAIL = 'SUPLIER_LIST_FAIL'